<template>
  <teleport to=".app-main-container">
    <div v-if="isOpen" class="modal-overlay" @click.self="closeModal">
      <div class="modal">
        <div class="modal-header">
          <slot name="header">
            <h2>Default Header</h2>
          </slot>
          <button
            @click="closeModal"
            class="close-button"
            aria-label="Close modal"
          >
            <font-awesome-icon :icon="['fas', 'xmark']" />
          </button>
        </div>
        <main class="modal-body">
          <slot name="body">
            <p>Default body content</p>
          </slot>
        </main>
        <div class="modal-footer">
          <slot name="footer">
            <button @click="closeModal" class="teal-button mt-4 w-100">
              Close
            </button>
          </slot>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { ref } from 'vue';

const isOpen = ref(false);

const openModal = () => {
  isOpen.value = true;
};

const closeModal = () => {
  isOpen.value = false;
};

defineExpose({ openModal, closeModal });
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  position: relative;
  border-radius: 16px;
  width: 85%;
  max-width: 500px;
  overflow: hidden;
  animation: modalIn 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

@keyframes modalIn {
  from {
    transform: scale(0.93) translateY(8px);
    opacity: 0;
  }
  to {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}

.light-theme .modal {
  background-color: #ffffff;
  border: 1px solid #e4eaee;
}

.dark-theme .modal {
  background-color: #212e3e;
  border: 1px solid #2a3a4e;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 18px 14px;
  border-bottom: 1px solid;
  margin-top: 0;
}

.light-theme .modal-header {
  border-color: #eef1f4;
}

.dark-theme .modal-header {
  border-color: #2a3a4e;
}

.modal-header h2 {
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 700;
  margin: 0;
  letter-spacing: -0.01em;
}

.light-theme .modal-header h2 {
  color: #004751;
}

.dark-theme .modal-header h2 {
  color: #ffffff;
}

.close-button {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  font-size: 13px;
  flex-shrink: 0;
  transition: opacity 0.15s ease;
}

.close-button:hover {
  opacity: 0.75;
}

.light-theme .close-button {
  background: #eef1f4;
  color: #556070;
}

.dark-theme .close-button {
  background: #2a3a4e;
  color: rgba(255, 255, 255, 0.7);
}

.modal-body {
  padding: 16px 18px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.65;
}

.light-theme .modal-body {
  color: #556070;
}

.dark-theme .modal-body {
  color: #a0b0c0;
}

.modal-footer {
  padding: 4px 18px 18px;
}
</style>

<style>
.modal-footer-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.modal-footer-buttons button {
  width: 100%;
}
</style>

<!-- <template>
  <teleport to=".app-main-container">
    <div v-if="isOpen" class="modal-overlay">
      <div class="modal">
        <div class="modal-header">
          <slot name="header">
            <h2>Default Header</h2>
          </slot>
          <button @click="closeModal" class="close-button">&times;</button>
        </div>
        <main class="modal-body">
          <slot name="body">
            <p>Default body content</p>
          </slot>
        </main>
        <div class="modal-footer">
          <slot name="footer">
            <button @click="closeModal" class="teal-button mt-4 w-100">
              Close
            </button>
          </slot>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { ref } from 'vue';

const isOpen = ref(false);

const openModal = () => {
  isOpen.value = true;
};

const closeModal = () => {
  isOpen.value = false;
};

defineExpose({ openModal, closeModal });
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  position: relative;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  max-width: 500px;
}

.light-theme .modal {
  background-color: #fff;
}

.dark-theme .modal {
  background-color: #212e3e;
}

.dark-theme .modal-body {
  color: #fff;
}

.modal-header {
  margin-top: 20px;
}

.dark-theme .modal-header {
  color: #fff;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 5px;
  line-height: 1;
}

.light-theme .close-button {
  color: #000;
}

.dark-theme .close-button {
  color: #fff;
}

.modal-footer {
  margin-top: 20px;
  text-align: right;
}
</style>

<style>
.modal-footer-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.modal-footer-buttons button {
  flex: 0 1 auto;
}
</style> -->
